import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Container, Typography, CircularProgress } from '@mui/material';
import { useGetConfigurations } from '../api/NewsQueueApi';
import NewsQueue from '../newsQueue';

export default function DeskPage() {
    const intl = useIntl();
    const { id } = useParams();
    const navigate = useNavigate();
    const configurationsQuery = useGetConfigurations({ enabled: true });

    useEffect(() => {
        if (configurationsQuery.isSuccess) {
            const mediaCollections = configurationsQuery?.data?.result?.media_collections || [];
            
            // Find the desk shortcut by URL match
            const deskShortcut = mediaCollections.find(collection => 
                collection.url === id
            );
            
            if (!deskShortcut) {
                // If desk shortcut not found, redirect to media selection
                navigate('/mediavalinta');
            }
        }
    }, [id, configurationsQuery.isSuccess, navigate]);

    if (configurationsQuery.isLoading) {
        return (
            <Container maxWidth="md" sx={{ py: 4, textAlign: 'center' }}>
                <CircularProgress />
            </Container>
        );
    }

    if (configurationsQuery.isSuccess) {
        const mediaCollections = configurationsQuery?.data?.result?.media_collections || [];
        const deskShortcut = mediaCollections.find(collection => collection.url === id);
        
        if (!deskShortcut) {
            return (
                <Container maxWidth="md" sx={{ py: 4 }}>
                    <Typography variant="h6">
                        {intl.formatMessage({ id: 'newsQueue.desk.notFound' })}: {id}
                    </Typography>
                </Container>
            );
        }
        
        // Render NewsQueue with desk shortcut information
        return (
            <NewsQueue 
                deskShortcut={deskShortcut}
                shortcutMedia={deskShortcut.target_medias}
            />
        );
    }

    return null;
}